import React from 'react';
import { Input, FormGroup, Label } from 'reactstrap';

type VbzTextAreaInputT = {
  name: string;
  textLabel: string;
  onChange: () => void;
  placeholder: string;
  error: boolean;
  errorMessage: string;
};

export default function VbzTextAreaInput(props: VbzTextAreaInputT) {
  return (
    <FormGroup className={`vbz_textarea_input ${props.error && 'on-error'}`}>
      <Label for={props.textLabel}>{props.textLabel}</Label>
      <Input type="textarea" onChange={props.onChange} placeholder={props.placeholder} name={props.name} />
      {props.error ? (
        <div className="vbz_textarea_input_error">
          <i className="material-icons">error_outline</i>
          <label htmlFor="input-text">{props.errorMessage}</label>
        </div>
      ) : null}
    </FormGroup>
  );
}
